<template>
    <div style="background: #fff" v-loading="loading">
        <!--banner-->
        <div class="nbanner" v-if="$util.isEmpty(keyword)"> 
           <a :href="item.adv_url?item.adv_url.url:'javascript:void(0)'" :target="item.adv_url?'_blank':''" v-for="item in bannerlist" :key="item.adv_id">
               <img :src="$util.img(item.adv_image)" alt="">
            </a>
            <!-- <img v-if="bannerlist.length<=0" src="@/assets/styles/images/ny1.png" alt="">   -->
        </div>
        <!--主体开始-->
        <div class="nding" v-if="!$util.isEmpty(keyword)">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/goods/goodslist">供应大厅</a>&gt; <a href="">{{keyword}}</a>
                <p style="float: right">共找到{{count}}条“{{keyword}}”商品信息</p>
            </div>
        </div>
        <div class="fenlei">
            <ul class="sh">
                <li><a :class="category_id_1 == '' ? 'on' : ''" href="javascript:void(0)" @click="skippage('')">全部</a></li>
                <li v-for="item in categoryList" :key="item.category_id"><a :class="item.category_id == category_id_1 ? 'on' : ''" @click="skippage(item.category_id)" href="javascript:void(0)">{{item.category_name}}</a></li>
            </ul>
            <div class="xia1">
                <ul v-for="item in childList" :key="item.category_id">
                    <h4>{{item.category_name}}</h4>
                    <div>
                        <li v-for="i in item.child_list" :key="i.category_id"><a :class="i.category_id == category_id ? 'on' : ''" href="javascript:void(0);" @click="skippage(i.category_id)" >{{i.category_name}}</a></li>
                    </div>
                </ul>
            </div>
        </div>
        <div class="fenlei" v-show="isshow">
            <div class="xia1">
                <ul v-for="item in attribute_list" :key="item.attr_id">
                    <h4>{{item.attr_name}}</h4>
                    <div>
                        <li v-for="i in item.child" :key="i.attr_value_id"><a :class="i.attr_value_id == attr_value_id ? 'on' : ''" href="javascript:void(0);" @click="changeattr(item.attr_id, i.attr_value_id)" >{{i.attr_value_name}}</a></li>
                    </div>
                </ul>
            </div>
        </div>
        <section class="section ncontainer1">
            <div class="neit">
                <div class="y">
                    <ul>
                        <li v-for="item in goodsList" :key="item.sku_id">
                            <router-link :to="{path:'/sku-'+item.sku_id}" target="_blank" tag="a"> 
                                <div><img :src="$img(item.sku_image)" alt=""></div>
                                <p><span v-if="item.is_free_shipping == 1" style="background-image: -webkit-linear-gradient( 0deg, rgb(255,149,0) 0%, rgb(255,107,0) 100%);">包邮</span>{{item.goods_name}}</p>
                                <div class="zi">
                                    <h4>{{item.discount_price}}<span>元</span></h4>
                                    <p v-if="is_sales_open">销量：{{ item.sale_num || 0 }}</p>
                                </div>
                                <!-- <div class="xia"><img src="@/assets/styles/images/dw.png" alt="">渭南市大荔县范家镇</div> -->
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="pages">
                <div class="Pagination"></div>
                <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
            </div>
        </section>
    </div>
</template>

<script>

import '@/assets/styles/js/jquery.pagination.js';
import { goodsSkuPage } from "@/api/goods/goods"
import { tree, getMenuList, goodsCategoryInfo, relevanceinfo } from '@/api/goods/goodscategory';
import { adList } from "@/api/website";

export default {
    data: () => {
        return {
			is_sales_open:0,
            loading: true,
            goodsList: [],
            pageCount:0,
            page_size:15,
            page:1,
            isshow: false,
            category_id:'',
            category_id_1:'',
            attr_value_id:'',
            categoryList:[],
            childList:[],
            categoryinfo:{},
            attribute_list:[],
            attr:'',
            keyword:'',
            count:0,
            bannerlist:[]
        }
    },
    created(e) {
        this.keyword = this.$route.query.keyword;
        if(!util.isEmpty(this.$route.query.category_id)) {
            this.category_id = this.$route.query.category_id;
            this.goodsCategoryInfo();
        }
        this.getTrees();
        this.getgoodsList();
        this.getbannerlist();
    },
    methods: {
        getbannerlist() {
            adList({
                keyword:"PC_GOODS_BANNER"
            }).then(res => {
                if(res.code == 0) {
                    this.bannerlist = res.data.adv_list.slice(0,1);
                    for (let i = 0; i < this.bannerlist.length; i++) {
                        if (this.bannerlist[i].adv_url) this.bannerlist[i].adv_url = JSON.parse(this.bannerlist[i].adv_url)
                    }
                }
            })
        },
        goodsCategoryInfo() {
            goodsCategoryInfo({
                category_id: this.category_id,
            }).then(res => {
                if(res.code == 0) {
                    this.categoryinfo = res.data;
                    if(!util.isEmpty(this.categoryinfo)) {
                        this.category_id_1 = this.categoryinfo.category_id_1;
                        this.getChild(this.category_id_1);
                        this.getrelevanceinfo(this.categoryinfo.level);
                    }
                }
            })
        },
        getTrees() {
            tree({
                level:1
            }).then(res => {
                if(res.code == 0) {
                    this.categoryList = res.data;
                }
            });
        },
        skippage(id) {
            location.href = !util.isEmpty(id) ? '/goods/goodslist?category_id=' + id : '/goods/goodslist';
			//this.$router.push({path:!util.isEmpty(id) ? '/goods/goodslist?category_id=' + id : '/goods/goodslist'})
			
        },
        getChild(id) {
            getMenuList({
                pid: id
            }).then(res => {
                if(res.code == 0) {
                    this.childList = res.data;
                }
            });
        },
        getrelevanceinfo(level) {
            relevanceinfo({
                category_id: this.category_id,
                category_level: level
            }).then(res => {
                if(res.code == 0) {
                    const { brand_list, attribute_list, brand_initial_list } = res.data
                    //this.brandList = brand_list
                    this.attribute_list = attribute_list
                    if(this.attribute_list.length>0) {
                        this.isshow = true;
                    }
                    //this.brandInitialList = brand_initial_list
                }
            })
        },
        changeattr(attr_id, attr_value_id) {
            this.attr_value_id = attr_value_id;
            var model = {attr_id:attr_id, attr_value_id:attr_value_id};
            var list = [];
            list.push(model);
            this.attr = JSON.stringify(list);
            this.getgoodsList();
        },
        getgoodsList() {
            this.loading = true;
            const params = {
                page_size: this.page_size,
                page: this.page,
                category_id: this.category_id,
                attr: this.attr,
                keyword: this.keyword
            }
            goodsSkuPage(params || {})
                .then(res => {
                    if(res.code == 0) {
						this.is_sales_open = res.data.is_sales_open
                        this.count = res.data.count;
                        this.pageCount = res.data.page_count;
                        $(".Pagination").pagination(this.pageCount, {
                            callback: this.changepage
                        });
                        this.goodsList = res.data.list
                    }
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                })
        },
        changepage(page_id) {
                this.loading = true;
                this.page = page_id + 1;
                goodsSkuPage({
                    page_size: this.page_size,
                    page: this.page,
                    category_id: this.category_id,
                    attr: this.attr,
                    keyword: this.keyword
                }).then(res => {
                    if(res.code == 0) {
                        this.goodsList = res.data.list
                        this.loading = false;
                    }
                });
        },
    },
}
</script>
